export const deepClone = (toClone) => {
    if (!toClone || typeof toClone !== 'object') {
        return toClone;
    }
    if (Array.isArray(toClone)) {
        return [...toClone].map(deepClone);
    }
    return Object.entries(toClone).reduce((obj, [key, value]) => ({ ...obj, [key]: deepClone(value) }), {});
};
